<template>
  <div>
    <Modal
      v-model="modalDialog"
      :title="`${title}`"
      :closable="false"
      :mask-closable="false"
      class="lottery-kind-setting"
    >
      <table
        class="TB_COLLAPSE"
        width="100%"
      >
        <thead>
          <th colspan="2">{{ title }}</th>
        </thead>
        <tbody>
          <tr>
            <th>彩种名称</th>
            <td>
              <Input
                v-if="stateModal.state == 1"
                maxlength="10"
                show-word-limit
                v-model="form.gamename"
                style="width: 80%"
              />
              <span v-else>{{form.gamename}}</span>
            </td>
          </tr>
          <tr>
            <th>显示次序</th>
            <td>
              <Input
                v-model="form.queue"
                style="width: 80%"
              />
            </td>
          </tr>
          <tr v-if="stateModal.state == 1">
            <th>站别类型</th>
            <td>
              <RadioGroup v-model="form.siteId">
                <Radio
                  :label="it.id"
                  v-for="it in sitelist"
                  :key="it.id"
                >{{it.value}}</Radio>
              </RadioGroup>
            </td>
          </tr>
          <tr v-if="stateModal.state == 1">
            <th>参考彩种系列</th>
            <td>
              <Select
                v-model="catenaId"
                style="width: 80%"
              >
                <Option
                  v-for="(it, key) in catenaIdArr"
                  :value="key"
                  :key="key"
                >{{ it }}</Option>
              </Select>
            </td>
          </tr>
          <tr v-if="stateModal.state == 1">
            <th>参考彩种</th>
            <td>
              <Select
                v-model="form.refergameid"
                style="width: 80%"
                @on-change="refergameidChange"
              >
                <Option
                  v-for="it in selectGameArr"
                  :value="it.lotid"
                  :key="it.lotid"
                >{{ it.gamename }}</Option>
              </Select>
            </td>
          </tr>
          <tr v-if="stateModal.state == 1">
            <th>开关盘时间</th>
            <td>
              <TimePicker
                v-model="form.date"
                type="timerange"
                placeholder="Select time"
                style="width: 80%"
                :editable="false"
              ></TimePicker>
              <Tooltip
                content="00:00:00-00:00:00为24小时"
                placement="top"
              >
                <Button
                  shape="circle"
                  icon="md-help"
                  size="small"
                  class="ml-1"
                ></Button>
              </Tooltip>
            </td>
          </tr>
          <tr v-if="stateModal.state == 1">
            <th>下注时间</th>
            <td>
              <Select
                v-model="betTimeData.type"
                style="width: 25%"
                class="mr-3"
                @on-change="betTimeDataTypeChange"
                :disabled="isDayLottery"
              >
                <Option
                  v-for="it in betTimeData.typeArr"
                  :value="it.val"
                  :key="it.val"
                >{{ it.text }}</Option>
              </Select>
              <Select
                v-model="betTimeData.unit"
                style="width: 25%"
                :disabled="isDayLottery"
              >
                <Option
                  v-for="it in betTimeData.unitArr[betTimeData.type]"
                  :value="it"
                  :key="`unit-${it}`"
                >{{ it }}</Option>
              </Select>
              <Tooltip
                content="日开采不得设定下注时间"
                placement="top"
              >
                <Button
                  shape="circle"
                  icon="md-help"
                  size="small"
                  class="ml-1"
                ></Button>
              </Tooltip>
            </td>
          </tr>
          <tr v-if="stateModal.state == 1">
            <th>目标RTP</th>
            <td>
              <Input
                v-model="form.rtp"
                style="width: 30%"
                :maxlength="9"
              />
              <span class="ml-2 pr">*设定范围：70%~105%</span>
            </td>
          </tr>
          <tr>
            <th>彩种LOGO</th>
            <td>
              <div
                class="inlineblock"
                style="width: 45%"
              >
                <Upload
                  name="img"
                  accept=".png"
                  :action="updateUrl"
                  :format="['png']"
                  :before-upload="upImgBefore"
                  :show-upload-list="false"
                  style="display: inline-block"
                  :max-size="500"
                >
                  <Button icon="ios-camera">选择图片</Button>
                </Upload>
                <p class="pr my-1">建议尺寸：150*150像素</p>
                <p class="pr my-1">建議大小: 500kb</p>
                <p class="pr">建议格式：PNG</p>
              </div>
              <div
                class="inlineblock text-center"
                style="width: 45%"
              >
                <img
                  :src="imgurl"
                  style="max-width: 75px"
                  @error="imgError"
                />
              </div>
            </td>
          </tr>
        </tbody>
      </table>
      <div slot="footer">
        <Button
          type="primary"
          @click="$emit('update:modal', false)"
        >取消
        </Button>
        <Button
          type="error"
          @click="checkfun()"
          :loading="btnloading"
        >
          {{ title }}
        </Button>
      </div>
    </Modal>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import { accNum } from "utils";
import GameGroupMethods from 'utils/game-group-methods.js'
import siteGroup from 'utils/site-group.js'
import defaultImg from "@/assets/img/defaultIcon.png"

export default {
  name: 'LotteryKindSetting',
  props: {
    modal: {
      type: Boolean
    },
    stateModal: {
      // state: { 1: 新增, 2: 修改 }
      type: Object
    },
    refergamearr: {
      type: Array
    }
  },
  data () {
    return {
      btnloading: false,
      modifyStatus: false,
      form: {
        gamename: "",
        queue: "",
        refergameid: "",
        siteId: 0,
        upidop: 1,
        date: ['00:00:00', '00:00:00'],
        betTime: '',
        rtp: '',
        remark: '_'
      },
      isDayLottery: false,
      catenaId: 0,
      betTimeData: {
        type: 1,
        typeArr: [
          { val: 1, text: '秒' },
          { val: 60, text: '分钟' },
          { val: 3600, text: '小时' }
        ],
        unit: 75,
        unitArr: {
          1: [75, 90],
          60: [1, 3, 5, 6, 10, 20, 30],
          3600: [1, 2, 3, 4, 6, 8, 12]
        }
      },
      imgFile: '',
      imgurl: defaultImg,
      updateUrl: process.env.VUE_APP_UPDATE_API
    };
  },
  computed: {
    ...mapGetters(["getmember"]),
    modalDialog: {
      get () {
        if (this.stateModal.state != 1) return this.modal && this.modifyStatus;
        if (this.stateModal.state == 1) return this.modal;
      },
      set (val) {
        this.modifyStatus = false
        this.$emit("update:modal", val);
      }
    },
    title () {
      return this.stateModal.state == 1 ? "新增自开采" : "修改彩种";
    },
    selectGameArr () {
      let selectGameArr = this.refergamearr.filter(it => it.catenaId == this.catenaId)
      return selectGameArr
    },
    catenaIdArr () {
      const gameGroupMethods = new GameGroupMethods()
      let obj = gameGroupMethods.catenaIdItems
      let arr = Array.from(new Set(this.refergamearr.map(it => it.catenaId)))
      delete obj['7'] // 新增自開彩動作移除基諾彩選項。
      Object.keys(obj).forEach(it => {
        if (arr.indexOf(Number(it)) == -1) delete obj[it]
      })
      return obj
    },
    sitelist () {
      return siteGroup.list()
    }
  },
  watch: {
    modal (val) {
      if (val && this.stateModal.state != 1) this.getLotteryKindGameData();
      if (!val) this.resetdata();
    }
  },
  methods: {
    ...mapActions(['setAllGameReset']),
    resetdata () {
      this.form = {
        gamename: "",
        queue: "",
        refergameid: "",
        siteId: 0,
        upidop: 1,
        date: ['00:00:00', '00:00:00'],
        betTime: '',
        rtp: '',
        remark: '_'
      }
      this.catenaId = 0
      this.betTimeData.type = 1
      this.betTimeData.unit = 75
      this.imgurl = defaultImg
    },
    async getLotteryKindGameData () {
      try {
        let res = await this.$axios.gameLobby.listDataTheGame(this.stateModal.listid)
        if ('status' in res && res.status === 0) return
        this.modifyStatus = true
        this.form = res[0]
        this.imgurl = `${process.env.VUE_APP_IMAGE_URL}/img/` + res[0].imgurl + ".jpge?" + new Date().getTime()
      } catch (error) {
        console.error(error)
        this.modalDialog = false
      }
    },
    async checkfun () {
      this.form.betTime = this.betTimeData.type * this.betTimeData.unit
      this.form.remark = this.form.remark ? this.form.remark : '_'
      if (!Object.values(this.form).every(it => String(it).length > 0)) return this.$Message.error("栏位请填写完成")
      if (!accNum.accPlusInt(this.form.queue) || this.form.queue < 1) return this.$Message.error("显示次序请填入一个大于0的整数")
      try {
        this.btnloading = true
        let res;
        let bodyFormData = new FormData();
        if (this.stateModal.state == 1) {
          if (isNaN(this.form.rtp) || this.form.rtp < 70 || this.form.rtp > 105) return this.$Message.error("RTP请输入一个70~105间的数字")
          this.form.queue = Number(this.form.queue)
          let { gamename, queue, upidop, siteId, refergameid, rtp, remark } = this.form
          let obj = {
            loid: this.getmember.pid,
            gamename,
            queue,
            upidop,
            siteId,
            refergameid,
            rtp,
            remark,
            bettime: this.isDayLottery ? 86400 : this.betTimeData.type * this.betTimeData.unit,
            optime: this.form.date[0],
            entime: this.form.date[1],
          }
          bodyFormData.append('objdata', JSON.stringify(obj));
          bodyFormData.append('Gimg', this.imgFile);
          res = await this.$axios.gameLobby.add(bodyFormData)
        }
        if (this.stateModal.state != 1) {
          let { lotid, gamename, queue, upidop, siteId, remark } = this.form
          let obj = {
            lotid,
            gamename,
            queue,
            upidop,
            siteId,
            remark
          }
          bodyFormData.append('objdata', JSON.stringify(obj));
          bodyFormData.append('Gimg', this.imgFile);
          res = await this.$axios.gameLobby.modify(bodyFormData)
        }
        if (res.status == 1 && res.img ? res.img[0].status == 1 : true) {
          this.$Message.success(`${this.stateModal.state == 1 ? '新增' : '修改'}成功`);
          this.setAllGameReset()
        } else {
          return this.$Message.success(`${this.stateModal.state == 1 ? '新增' : '修改'}失敗`)
        }
        this.$emit("ResetList");
        this.modalDialog = false
      } catch (error) {
        console.error(error)
      } finally {
        this.btnloading = false
      }
    },
    upImgBefore (file, type) {
      if (file.size > 500 * 1024) return this.$Message.error('图片过大')
      const objectURL = URL.createObjectURL(file);
      this.imgFile = file
      this.imgurl = objectURL
      return false
    },
    betTimeDataTypeChange (val) {
      this.betTimeData.unit = val == 1 ? 75 : 1
    },
    refergameidChange (id) {
      const arr = [16, 23, 34]
      this.isDayLottery = arr.some(it => it == this.form.refergameid)
      const find = this.refergamearr.find(it => it.lotid == id)
      if (!find) return
      this.form.date = find.openInterval.split(',')
      const timeArr = [
        Math.floor(find.bettime / 3600),
        Math.floor(find.bettime % 3600 / 60),
        Math.floor(find.bettime % 3600 % 60),
      ]
      if (timeArr[0]) this.betTimeData.type = 3600, this.betTimeData.unit = timeArr[0]
      if (timeArr[1]) this.betTimeData.type = 60, this.betTimeData.unit = timeArr[1]
      if (timeArr[2]) this.betTimeData.type = 1, this.betTimeData.unit = timeArr[2]
      if (find.bettime == 75 || find.bettime == 90) this.betTimeData.type = 1, this.betTimeData.unit = find.bettime
    },
    imgError () {
      this.imgurl = defaultImg
    }
  }
};
</script>

<style lang="scss">
.lottery-kind-setting {
  table.TB_COLLAPSE tbody {
    text-align: left;
    th {
      text-align: center;
      padding: 10px;
    }
    td {
      text-align: left;
      padding-left: 2rem;
    }
  }
}
</style>